import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", " ", ";\n  ", ";\n  padding: 0 0;\n  user-select: none;\n\n  > ", " {\n    width: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border:", " solid ", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.progressBar.borders.borderWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.progressBar.borders.borderColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.progressBar.borders.borderRadius;
});
var before = css(["&:before{background:", ";border-radius:", ";content:' ';height:100%;position:absolute;transition:width ", "ms;width:", "%;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.progressBar.colors.fill;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.progressBar.borders.borderRadius;
}, function (_ref6) {
  var fillingSpeed = _ref6.fillingSpeed;
  return fillingSpeed;
}, function (_ref7) {
  var percent = _ref7.percent;
  return percent;
});
var colors = css(["background:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.progressBar.colors.background;
});
var positionFirstComponent = css(["display:flex;justify-content:", ";position:relative;justify-content:space-between;"], function (_ref9) {
  var fillingOrientation = _ref9.fillingOrientation;
  return fillingOrientation;
});
var positionText = css(["> ", "{color:", ";display:flex;justify-content:center;margin:0;position:relative;width:100%;align-items:center;}"], Text, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.progressBar.colors.text;
});
var size = css(["", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return "\n    height: ".concat(theme.components.progressBar.sizes.height, ";\n    width: ").concat(theme.components.progressBar.sizes.width, ";\n  ");
});
var StyledProgressBar = styled.div(_templateObject(), before, borders, colors, positionFirstComponent, positionText, size, Text);

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A basic progress bar, which shows filling percentage.
 *
 */

var ProgressBar = function ProgressBar(_ref) {
  var fillingOrientation = _ref.fillingOrientation,
      fillingSpeed = _ref.fillingSpeed,
      start = _ref.start,
      end = _ref.end,
      step = _ref.step,
      value = _ref.value,
      label = _ref.label,
      leftLabel = _ref.leftLabel,
      rightLabel = _ref.rightLabel,
      rest = _objectWithoutProperties(_ref, ["fillingOrientation", "fillingSpeed", "start", "end", "step", "value", "label", "leftLabel", "rightLabel"]);

  var roundToStep = function roundToStep(value, step) {
    return Math.round(value / step) * step;
  };

  var normalizedValue = Math.min(Math.max(parseFloat(value), start), end);
  var percent = roundToStep(normalizedValue * 100 / (end - start), step);
  var stepLabel = !!label ? label : "".concat(roundToStep(value, step) - start, "/").concat(end - start, "%");
  return React.createElement(StyledProgressBar, _extends({
    end: end,
    fillingOrientation: fillingOrientation,
    fillingSpeed: fillingSpeed,
    percent: percent,
    start: start
  }, rest), React.createElement(Text, null, leftLabel), React.createElement(Text, null, stepLabel), React.createElement(Text, null, rightLabel));
};

ProgressBar.defaultProps = {
  end: 100,
  fillingOrientation: 'left',
  fillingSpeed: 100,
  start: 0,
  step: 1,
  value: 0,
  leftLabel: '',
  rightLabel: '',
  label: null
};
ProgressBar.propTypes = {
  /**
   * End of the progressbar.
   */
  end: PropTypes.number,

  /**
   * Tells how the progressbar will be filled (left, center or right).
   */
  fillingOrientation: PropTypes.oneOf(['left', 'center', 'right']),

  /**
   * Define the filling speed of the progressbar.
   */
  fillingSpeed: PropTypes.number,

  /**
   * Define the label text.
   */
  label: PropTypes.string,

  /**
   * Define the left label text.
   */
  leftLabel: PropTypes.string,

  /**
   * Define the right label.
   */
  rightLabel: PropTypes.string,

  /**
   * Beginning of the progressbar.
   */
  start: PropTypes.number,

  /**
   * Incremental step.
   */
  step: PropTypes.number,

  /**
   * Progressbar value.
   */
  value: PropTypes.number
};
/** @component */

var index = styled(ProgressBar)(_templateObject$1());

export default index;
